import { camelCase, capitalize } from 'lodash';
import { TASK_TYPES } from './constants';

export function getTaskTypeLabel(taskType) {
  const type = TASK_TYPES[camelCase(taskType)];
  return type ? type.label : capitalize(taskType);
}
